import { Any } from 'microstates';

export default class PhotoState {
  isHoveringPhoto = Boolean;
  isEditingPhoto = Boolean;
  isChangingPhoto = Boolean;
  photoSrc = String;
  originalPhotoSrc = String;
  cropper = Any;
  photoUploadProgress = Number;
  addingPhoto = Boolean;
  zoomRatio = Number;
  rotation = Number;
  blob = Any;


  get showPhotoPrompt() {
    return !this.hasPhoto || this.hasPhoto && this.isHoveringPhoto.state;
  }

  get hasPhoto() {
    return this.photoSrc.state.length > 0;
  }

  commitPhotoEdits(photo) {
    return this.isChangingPhoto.state
      ? this.photoSrc.set(photo)
            .photoUploadProgress.set(0)
            .isHoveringPhoto.set(false)
      : this.isEditingPhoto.toggle()
            .photoSrc.set(photo)
            .isHoveringPhoto.set(false)
            .photoUploadProgress.set(0);
  }
}
